// src/routes.js
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import ForgotPassword from './pages/ForgotPassword/forgot-password';
import ResetPassword from './pages/ForgotPassword/reset-password';
import AddChatBot from './pages/Home';
import Training from './pages/Training';
import BotCustomization from './pages/BotCustom';
import ShopifyCallback from './util/shopifycallback';
import Chats from './pages/Chats';
import Analytics from './pages/Subscription';
import TeamsPage from './pages/terms';
import Privacy from './pages/privacy';
import FeedBack from './pages/Feedback';
import TicketManagement from './pages/TicketManagement';
import SubscriptionPage from './pages/Subscription';
import Reports from './pages/Analytics/analytics';

// Define routes in an array
const routes = [
  {
    path: '/',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  // 👇 Home stays without store_id
  {
    path: '/home',
    element: <AddChatBot />,
  },
  // 👇 All store-specific routes include :store_id
  {
    path: '/store/:store_id/training',
    element: <Training />,
  },
  {
    path: '/store/:store_id/bot-customization',
    element: <BotCustomization />,
  },
  {
    path: '/store/:store_id/ticket-management',
    element: <TicketManagement />,
  },
  {
    path: '/store/:store_id/chats',
    element: <Chats />,
  },
  {
    path: '/store/:store_id/feedback',
    element: <FeedBack />,
  },
  {
    path: '/store/:store_id/subscription',
    element: <SubscriptionPage />,
  },
  {
    path: '/store/:store_id/analytics',
    element: <Reports />,
  },
  {
    path: '/shopify/callback',
    element: <ShopifyCallback />,
  },
  {
    path: '/pages/terms-conditions',
    element: <TeamsPage />,
  },
  {
    path: '/pages/privacy-policy',
    element: <Privacy />,
  },
];

export default routes;
